import { http } from '../../core/services'

export const loadUnapprovedPublications = () =>
  http.get('management/publications/unapproved').then(response => response.data)

export const approvePublication = id =>
  http.patch(`management/publications/${id}/approve`)
